export const emailTemplate =
  () =>
  ({ projects: { emailTemplate } }) =>
    emailTemplate;

export const emailTemplateError =
  () =>
  ({ projects: { emailTemplateError } }) =>
    emailTemplateError;
